import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { setRef } from '@sheerid/jslib';

interface PassedProps {
    onKeyDown?: Function;
}

interface FormFieldComponentProps {
    value: any;
    onChange: Function;
    isErrored?: boolean;
    placeholder?: string;
}

const LinkedInUrlComponent = ({
    value,
    isErrored,
    onChange,
    onKeyDown = undefined,
    placeholder = '',
}: FormFieldComponentProps & PassedProps) => (
    <div className="sid-field sid-email">
        <div className="sid-l-space-top-md" />
        <label htmlFor="sid-email">
            <div className={`sid-field__label-with-explanation sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                <div className="sid-field__label sid-field__label--required">
                    <FormattedHTMLMessage
                        id="linkedInUrl"
                        defaultMessage="LinkedIn Profile URL"
                    />
                </div>
            </div>
        </label>
        <input
            className={
                `sid-text-input sid-text-input--required
                    sid-l-full-width sid-hidden-placeholder ${isErrored ? 'sid-text-input--error' : ''}`
            }
            id="sid-linked-in-url"
            name="sid-linked-in-url"
            type="text"
            value={value}
            onChange={e => onChange(e.target.value)}
            onKeyDown={typeof onKeyDown === 'function' ? e => onKeyDown(e) : undefined}
            placeholder={placeholder}
            ref={input => setRef('linked-in-url', input)}
        />
        <div className="sid-field__label sid-linked-in-label">
            <FormattedHTMLMessage
                id="urlExplanation"
                defaultMessage="(Example: https://www.linkedin.com/in/john-smith-a12345678/)"
            />
        </div>
    </div>
);

export { LinkedInUrlComponent };
